module.exports = __webpack_public_path__ + "static/media/productProcessIntro.6e366f4a.svg";